import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ChargeUserForGourmetWithPartnerSubsidyIfAvailableInput } from '@/models/gourmet';

export const chargeUserForGourmetWithPartnerSubsidyIfAvailable = async ({
  callerId,
  amount,
  currency,
  notes,
  category,
}: ChargeUserForGourmetWithPartnerSubsidyIfAvailableInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ChargeUserForGourmetWithPartnerSubsidyIfAvailable(
        $callerId: String!
        $amount: Float!
        $currency: String!
        $notes: String!
        $category: Float!
      ) {
        chargeUserForGourmetWithPartnerSubsidyIfAvailable(
          callerId: $callerId
          amount: $amount
          currency: $currency
          notes: $notes
          category: $category
        ) {
          id
        }
      }
    `),
    variables: {
      callerId,
      amount,
      currency,
      notes,
      category,
    },
  });

  return !!response.data?.chargeUserForGourmetWithPartnerSubsidyIfAvailable;
};
